import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from './services/language-service.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  constructor(
    private translate: TranslateService,
    private langService:LanguageService
  ){
    let lang = localStorage.getItem('language') || 'de'
    console.log('lang',localStorage.getItem('language')|| 'de')
    this.translate.setDefaultLang(lang);
    this.translate.use(lang);
    this.langService.activeLanguage = lang;

  }

}
